module.exports = __webpack_public_path__ + "img/money.69e50ce3.svg";